import * as yup from "yup";

import { IRedirectToInvoice } from "../../../../interfaces-and-types";
import { chargeBearer } from "../../../../enums";

export const redirectToInvoiceSchema: yup.SchemaOf<IRedirectToInvoice> = yup
  .object({
    transfer_refund_id: yup
      .string()
      .required("Please provide the transfer refund id"),
    tx_or_invoice_reference: yup
      .string()
      .required(
        "Please provide the target invoice reference for the same customer"
      ),
    max_partial_payment_count: yup
      .number()
      .typeError("Permitted partial payment count is required")
      .required("Permitted partial payment count is required")
      .positive(
        "Please set the permitted number of partial payemnts the customer can make to complete payment"
      ),
    bearer: yup
      .mixed<chargeBearer>()
      .oneOf(Object.values(chargeBearer))
      .required("charge bearer is required"),
    description: yup.string().nullable().optional().max(300),
  })
  .required();
